import { SharedConstants } from "../../../../shared/constants/shared.constants";
export class AttributesAndParametersConstants {
    // headings
    static CONTENT_PAGE_HEADING = "Attributes and parameters";
    static HOME_MENU_HEADING = "Home";
    static PARAMETERS_MENU_HEADING = "Parameters";
    static FACTOR_ADJUSTMENT_MENU_HEADING = "Factor adjustment";
    static STRUCTURE_TYPE_MENU_HEADING = "Structure type";
    static VALUE_ADJUSTMENT_MENU_HEADING = "Value adjustment";
    static VALUATION_RUN_SURVEY_HEADING = "Run Survey";
    static DEPRECIATION_FACTOR_MENU_HEADINGS = "Depreciation factor";
    static AGRICULATURAL_ACTIVITY_MENU_HEADINGS = "Agricultural activity";
    // labels
    static SELECT_GENERAL_VALUATION_RUN_LABEL = "Select project cycle";
    // form controls
    static SELECT_GENERAL_VALUATION_RUN_FORM_CONTROL = "selectprojectCycle";
    // error messages
    static NO_GV_FOUND_ERR_MSG = "There are no valuations found for the selected date please select a different date";
    static NO_GVR_SELECTED = "No project cycle selected";
    static NO_GVR_MESSAGE = "Attributes and factors are set on each project cycle. Please select a project cycle first before continuing.";
    static DELETE_MESSAGE = SharedConstants.DELETE_LABEL + " structure types successful";
    static BUTTONS_DISABLED_MSG = "No modifications to the data is allowed due to surveys that has been created already";
}
